export default __webpack_public_path__ + "static/media/logo.48153ba6.png";